<script>
	import { sendGTM } from '$lib/analytics'
	import { ContentWrapper, ContentHead, Saos, GuideBox } from '$lib/components'
	//import Expander from '$lib/components/Expander.svelte'
	import Header from '$lib/components/header-2.0/Header.svelte'
	import { URLPART_TYPE_LISTING } from '$lib/consts'
	import { ArticleV4, BlogBanner } from '$lib/modules/blog'
	import DynamicPageWrapper from '$lib/modules/cms/DynamicPageWrapper/DynamicPageWrapper.svelte'
	import DynamicZone from '$lib/modules/cms/DynamicZone/DynamicZone.svelte'
	import SectionHero from '$lib/modules/layout/SectionHero.svelte'
	import AdvantageBox from '$lib/modules/products/AdvantageBox.svelte'
	import FAQ_wrap from '$lib/modules/products/FAQ_wrap.svelte'
	import InstalationStep from '$lib/modules/products/InstalationStep.svelte'
	import {
		HEAT_PUMP,
		LEAVE_CONTACT,
		MEETING,
		WOLTADVISOR,
		FINANCING,
		GRANTS,
		SERVICE,
		GUARANTEE,
		HEAT_PUMP_3050
	} from '$lib/routes'
	import { t } from '$lib/translations'
	import { Anchor, Button } from '$lib/ui-woltair/components'
	import Separator from '$lib/ui-woltair/components/Separator.svelte'
	import Tabs from './@modules/ComparationTabs.svelte'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'
	import { MARKETPLACE } from '$params/marketplace'

	export let data = null

	export const header = {
		heading: t('web.heat_pump.header.heading'),
		subheading: t('web.heat_pump.header.subheading'),
		references_subtext: t('web.heat_pump.header.referencesSubtext'),
		subtext: t('web.heat_pump.header.subtext', {
			link: `/${HEAT_PUMP_3050}`
		})
	}

	const comparationTabs = [
		{
			...(data?.advisorDefaultElectric && {
				id: 'tab1',
				label: 'Elektrický kotel',
				content: data.advisorDefaultElectric
			})
		},
		{
			...(data?.advisorDefaultGas && {
				id: 'tab2',
				label: 'Plynový kotel',
				content: data?.advisorDefaultGas
			})
		},
		{
			...(data?.advisorDefaultCoal && {
				id: 'tab3',
				label: 'Tuhá paliva',
				content: data.advisorDefaultCoal
			})
		}
	]

	const homeanimation = 'default-in 1s cubic-bezier(0.35, 0.5, 0.65, 0.95) both'

	const instalationSteps = [
		{
			number: '1', // just for organizing data, display number is derived from index
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step1.timing',
			title: 'web.heat_pump.realization.step1.title',
			text: 'web.heat_pump.realization.step1.text',
			button: {
				text: 'web.heat_pump.realization.orderButtonText',
				link: `/${HEAT_PUMP}/${MEETING}`,
				condition: data.featureConfig.meeting.hvac
			}
		},
		{
			number: '2',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step2.timing',
			title: 'web.heat_pump.realization.step2.title',
			text: 'web.heat_pump.realization.step2.text'
		},
		{
			number: '3',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step3.timing',
			title: 'web.heat_pump.realization.step3.title',
			text: 'web.heat_pump.realization.step3.text',
			hidden: true
		},
		{
			number: '4',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step4.timing',
			title: 'web.heat_pump.realization.step4.title',
			text: 'web.heat_pump.realization.step4.text',
			hidden: true
		},
		{
			number: '5',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step5.timing',
			title: 'web.heat_pump.realization.step5.title',
			text: 'web.heat_pump.realization.step5.text',
			hidden: true
		},
		{
			number: '6',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step7.timing',
			title: 'web.heat_pump.realization.step7.title',
			text: 'web.heat_pump.realization.step7.text',
			hidden: true
		},
		{
			number: '7',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step8.timing',
			title: 'web.heat_pump.realization.step8.title',
			text: 'web.heat_pump.realization.step8.text',
			hidden: true
		},
		{
			number: '8',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step9.timing',
			title: 'web.heat_pump.realization.step9.title',
			text: 'web.heat_pump.realization.step9.text',
			hidden: true
		},
		{
			number: '9',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step10.timing',
			title: 'web.heat_pump.realization.step10.title',
			text: 'web.heat_pump.realization.step10.text',
			hidden: true
		},
		{
			number: '10',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step11.timing',
			title: 'web.heat_pump.realization.step11.title',
			text: 'web.heat_pump.realization.step11.text',
			hidden: true
		},
		{
			number: '11',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step12.timing',
			title: 'web.heat_pump.realization.step12.title',
			text: 'web.heat_pump.realization.step12.text',
			hidden: true
		},
		{
			number: '12',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step13.timing',
			title: 'web.heat_pump.realization.step13.title',
			text: 'web.heat_pump.realization.step13.text',
			hidden: true
		},
		{
			number: '13',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL'],
			timing: 'web.heat_pump.realization.step14.timing',
			title: 'web.heat_pump.realization.step14.title',
			text: 'web.heat_pump.realization.step14.text'
		},
		{
			number: '14',
			locales: ['WOLTAIR_CZ', 'WOLTAIR_PL', 'WOLTAIR_DE', 'WOLTAIR_IT'],
			timing: 'web.heat_pump.realization.step15.timing',
			title: 'web.heat_pump.realization.step15.title',
			text: 'web.heat_pump.realization.step15.text'
		}
	].filter((step) => step.locales.includes(PUBLIC_WOLTAIR_WEB_CODE))

	const extraSteps = {
		parentNum: 2, //marks element that will have child elements
		childNums: [
			{ number: '3', color: 'bg-neutral-800' },
			{ number: '4', color: 'bg-neutral-700' },
			{ number: '5', color: 'bg-neutral-600' },
			{ number: '6', color: 'bg-neutral-400' },
			{ number: '7', color: 'bg-neutral-200' }
		]
	}

	const imports = {
		Expander: () => import('$lib/components/Expander.svelte')
	}
</script>

{#if data.type === 'productPage' && data.components}
	<DynamicPageWrapper
		header={data.header}
		title={data.title}
		components={data.components}
		type={data.type}
	/>
{:else}
	<!-- TODO: Delete the PUBLIC_WOLTAIR_WEB_CODE condition once DE references will be ready -->
	<!-- SHOW REFERENCES -->
	<Header
		{header}
		references={data?.references}
		showReferences={data.featureConfig.references.hvac ||
			PUBLIC_WOLTAIR_WEB_CODE == 'WOLTAIR_DE' ||
			PUBLIC_WOLTAIR_WEB_CODE == 'WOLTAIR_IT'}
		headerAsterisk={data.featureConfig.thirtyFifty.hvac}
		showSubtext={data.featureConfig.thirtyFifty.hvac}
	>
		<svelte:fragment slot="buttonArea">
			<div class="relative">
				{#if data.featureConfig.woltadvisor.hvac}
					<div class="flex pt-8 md:-mt-2-res md:pt-16">
						<a
							class="btn btn-filled-primary text-base-res"
							href="/{HEAT_PUMP}/{WOLTADVISOR}"
							data-testid="calculator">{t('web.heat_pump.header.calculator.text')}</a
						>

						<div class="relative hidden min-h-full w-full md:block">
							<img
								src="/images/icons/arrow-handdrawn.svg"
								alt=""
								class="absolute bottom-8 right-3/4 max-h-8 w-1/5"
							/>
							<img
								src="/images/misc/head-offer.webp"
								alt=""
								class="absolute -bottom-2 right-0 max-h-28 w-8/12 object-contain md:-top-12"
							/>
						</div>
					</div>
				{/if}
				{#if data.featureConfig.meeting.hvac}
					<div>
						<a
							class="btn btn-outline-accent-red wrap relative z-10 mt-4 text-base-res"
							href="/{HEAT_PUMP}/{LEAVE_CONTACT}"
							data-testid="meeting"
							on:click={() => sendGTM('online_meet')}
							>{t('web.forms.leaveContact.button')}
						</a>
					</div>
				{/if}
			</div>
		</svelte:fragment>
		<svelte:fragment slot="bottom">
			{#if PUBLIC_WOLTAIR_WEB_CODE == 'WOLTAIR_CZ'}
				<a href="/{HEAT_PUMP}/{FINANCING}"
					><img
						class="page-wrapper mt-12 hidden md:block"
						src="/images/banners/HVAC-financovani-desktop-1.webp"
						alt="Financujte tepelné čerpadlo z úspor za energie"
						width="1328px"
						height="180px"
					/>
					<img
						class="page-wrapper mt-12 md:hidden"
						src="/images/banners/HVAC-financovani-mobile-1.webp"
						alt="Financujte tepelné čerpadlo z úspor za energie"
						width="400px"
						height="190px"
						loading="lazy"
					/></a
				>
			{/if}
			{#if data.featureConfig.thirtyFifty.hvac && PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_PL'}
				<section class="page-wrapper">
					<div
						class="mb-8 mt-10 grid grid-cols-1 items-center gap-8 rounded-2xl bg-gradient-to-r from-primary-500 to-[#e0154a] px-6 py-10 text-white shadow-2xl lg:grid-cols-12"
					>
						<div class="flex justify-center text-center text-6.5xl font-extrabold lg:col-span-3">
							{#if PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_DE'}
								<img src="/images/logos/30-50-logo-DE.webp" class="max-h-44" alt="30/50" />
							{:else}
								30/50
							{/if}
						</div>
						<div
							class="max-sm:center text-lg font-extrabold md:text-left md:text-2.5xl lg:col-span-6"
						>
							{t('web.homepage.PUBLIC.block3050.mainText')}
						</div>
						<div class="center text-center lg:col-span-3">
							<a
								href="/{HEAT_PUMP_3050}"
								class="whitespace-nowrap rounded-full bg-neutral-800 px-8 py-4 text-base text-white"
								>{t('web.homepage.PUBLIC.block3050.button.text')}</a
							>
						</div>
					</div>
				</section>
			{/if}
		</svelte:fragment>
	</Header>

	{#if data.featureConfig.grants.hvac || data.featureConfig.service || data.featureConfig.financing.hvac || data.featureConfig.guarantee.hvac}
		<div class="header page-fullwidth z-0 bg-neutral-100 pb-16-res" />
		<section class="boxes page-wrapper relative z-10 -mt-16-res grid gap-5 lg:grid-cols-2">
			{#if data.featureConfig.grants.hvac}
				<AdvantageBox
					textWidth="basis-[60%]"
					subtextWidth="max-w-[80%]"
					imageCls="scale-125 lg:-translate-y-10"
					content={{
						buttonTestId: 'advantage-grants',
						header: 'web.heat_pump.boxes.box1.header',
						text: 'web.heat_pump.boxes.box1.text',
						buttonText: 'web.heat_pump.boxes.box1.buttonText',
						buttonUrl: `/${HEAT_PUMP}/${GRANTS}`,
						headingAnchor: `/${HEAT_PUMP}/${GRANTS}`,
						imageAnchor: `/${HEAT_PUMP}/${GRANTS}`,
						imageUrl: '/images/illustrations/house.webp',
						imageAlt: t('web.heat_pump.boxes.box1.img.alt')
					}}
				/>
			{/if}
			{#if data.featureConfig.service}
				<AdvantageBox
					textWidth="basis-[70%]"
					subtextWidth="max-w-[60%]"
					content={{
						buttonTestId: 'advantage-service',
						header: 'web.heat_pump.boxes.box2.header',
						text: 'web.heat_pump.boxes.box2.text',
						buttonText: 'web.heat_pump.boxes.box2.buttonText',
						buttonUrl: `/${SERVICE}/${HEAT_PUMP}`,
						headingAnchor: `/${SERVICE}/${HEAT_PUMP}`,
						imageAnchor: `/${SERVICE}/${HEAT_PUMP}`,
						imageUrl: '/images/illustrations/technician.webp',
						imageAlt: t('web.heat_pump.boxes.box2.img.alt')
					}}
				/>
			{/if}
			{#if data.featureConfig.financing.hvac}
				<AdvantageBox
					textWidth="basis-[65%]"
					subtextWidth="max-w-[80%]"
					imageCls="lg:scale-125 lg:-translate-x-6 lg:-translate-y-10"
					content={{
						buttonTestId: 'advantage-financing',
						header: 'web.heat_pump.boxes.box3.header',
						text: 'web.heat_pump.boxes.box3.text',
						buttonText: 'web.heat_pump.boxes.box3.buttonText',
						buttonUrl: `/${HEAT_PUMP}/${FINANCING}`,
						headingAnchor: `/${HEAT_PUMP}/${FINANCING}`,
						imageAnchor: `/${HEAT_PUMP}/${FINANCING}`,
						imageUrl: {
							WOLTAIR_CZ: '/images/illustrations/safe.webp',
							WOLTAIR_PL: '/images/illustrations/safe-nologo.webp',
							WOLTAIR_DE: '',
							WOLTAIR_IT: ''
						}[PUBLIC_WOLTAIR_WEB_CODE],
						imageAlt: t('web.heat_pump.boxes.box3.img.alt')
					}}
				/>
			{/if}
			{#if data.featureConfig.guarantee.hvac}
				<AdvantageBox
					textWidth="basis-[60%]"
					subtextWidth="max-w-full"
					woltairW
					textColor="text-white"
					bgColor="bg-primary-500"
					buttonClass="btn-filled-white"
					content={{
						buttonTestId: 'advantage-guarantee',
						header: 'web.heat_pump.boxes.box4.header',
						text: 'web.heat_pump.boxes.box4.text',
						buttonText: 'web.heat_pump.boxes.box4.buttonText',
						buttonUrl: `/${GUARANTEE}`,
						headingAnchor: `/${GUARANTEE}`
					}}
				/>
			{/if}
		</section>
	{/if}

	{#if data.components}
		<section class="page-wrapper my-12">
			<DynamicZone componentData={data.components} />
		</section>
	{/if}

	{#if data.featureConfig.comparison.hvac && comparationTabs.some((tab) => tab?.content)}
		<section
			class="page-fullwidth relative mt-16-res bg-[url(/images/logos/woltair_bg_gray.svg)] bg-cover"
		>
			<SectionHero bgColor opaque bgImage="/images/logos/woltair_bg_gray.svg" />
			<ContentWrapper cls="px-6 pt-6 pb-16">
				<Saos animation={homeanimation}>
					<ContentHead subheadingWeight="text-xs pb-6" textAlign="text-center">
						<svelte:fragment slot="superheading">Srovnání</svelte:fragment>
						<svelte:fragment>Čím nyní topíte?</svelte:fragment>
						<svelte:fragment slot="subheading">
							Příklad pro 4 člennou rodinu v domě 150 m², se střední izolací a s cenou za energie 8
							Kč za kWh.
						</svelte:fragment>
					</ContentHead>
				</Saos>
				<Saos animation={homeanimation}>
					<Tabs tabs={comparationTabs} />
				</Saos>
			</ContentWrapper>
		</section>
	{/if}

	{#if data.featureConfig.guide.hvac}
		<section class="page-wrapper mt-24-res">
			<Separator />
			<h2
				class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
			>
				{t('web.heat_pump.guide.title')}
			</h2>

			<div
				class="inset-0 mx-auto mt-12 grid max-w-6xl grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3"
			>
				<GuideBox
					title={t('web.heat_pump.guide.box1.title')}
					text={t('web.heat_pump.guide.box1.text')}
					link={t('web.heat_pump.guide.box1.link')}
				/>
				<GuideBox
					title={t('web.heat_pump.guide.box2.title')}
					text={t('web.heat_pump.guide.box2.text')}
					link={t('web.heat_pump.guide.box2.link')}
				/>
				<GuideBox
					title={t('web.heat_pump.guide.box3.title')}
					text={t('web.heat_pump.guide.box3.text')}
					link={t('web.heat_pump.guide.box3.link')}
				/>
			</div>
		</section>
	{/if}

	{#if data.featureConfig.realization.hvac}
		<Anchor
			id={{
				WOLTAIR_CZ: 'instalace',
				WOLTAIR_PL: 'instalacja',
				WOLTAIR_DE: 'installation',
				WOLTAIR_IT: 'installazione'
			}[PUBLIC_WOLTAIR_WEB_CODE] || 'install'}
		/>
		<section id="realizations" class="page-wrapper mt-24-res">
			<Separator />
			<h2
				class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
			>
				{t('web.heat_pump.realization.heading')}
			</h2>
			<section class="mt-20-res">
				{#await imports['Expander']() then module}
					<svelte:component this={module.default} let:expand let:expanded>
						<div class="grid grid-cols-7 md:grid-cols-10 md:gap-20">
							<div class="col-span-7 md:col-span-6">
								{#each instalationSteps as step, i}
									<InstalationStep
										hideTiming={data.featureConfig.hvacNoTiming}
										cls={!expanded && step.hidden && i !== instalationSteps.length - 1
											? 'hidden'
											: 'isExpanded'}
										noborder={i === instalationSteps.length - 1 ? '' : 'middle-line'}
									>
										<svelte:fragment slot="timing">{t(step.timing)}</svelte:fragment>
										<svelte:fragment slot="num">{i + 1}</svelte:fragment>
										<svelte:fragment slot="extrasteps">
											{#if extraSteps.parentNum.toString() === step.number}
												{#each extraSteps.childNums as extraStep}
													<div
														class="{expanded
															? 'toExpand'
															: 'flex'}  mt-4 h-6 w-6 items-center justify-center rounded-full {extraStep.color} text-center text-xs text-white"
													>
														{extraStep.number}
													</div>
												{/each}
											{/if}
										</svelte:fragment>
										<svelte:fragment slot="title">{t(step.title)}</svelte:fragment>
										<svelte:fragment slot="content">
											<p class="text-xs leading-5">
												{t(step.text)}
											</p>
											{#if extraSteps.parentNum.toString() === step.number}
												<Button
													on:click={expand}
													on:keypress={expand}
													tiny
													tertiary
													cls="mt-6 {expanded ? 'hidden' : ''} !text-xs sm:!text-sm"
												>
													{t('web.heat_pump.realization.expandButtonText')}
												</Button>
											{:else if step.button && step.button?.condition}
												<Button tiny href={step.button.link} cls="mt-6 !text-xs sm:!text-sm"
													>{t(step.button.text)}</Button
												>
											{/if}
										</svelte:fragment>
									</InstalationStep>
								{/each}

								<InstalationStep hideTiming={data.featureConfig.hvacNoTiming} noborder>
									<svelte:fragment slot="content">
										<Button
											on:keypress={expand}
											on:click={expand}
											tiny
											tertiary
											cls="mt-4 {expanded ? '' : '!hidden'} !text-xs sm:!text-sm"
										>
											{t('web.heat_pump.realization.hideButtonText')}
										</Button>
									</svelte:fragment>
								</InstalationStep>
							</div>
							<div
								class="elative col-span-4 hidden grid-flow-row-dense content-start gap-3 md:grid lg:col-span-4 lg:pr-0"
							>
								<div class="sticky top-[max(20vh,100px)]">
									<video
										loop
										autoplay
										muted
										playsinline
										src="/videos/smycka.mov"
										type="video/mov"
									/>
									<p class="mt-2 text-lg font-light leading-normal text-neutral-500">
										{t('web.heat_pump.installation.videoSubtext')}
									</p>
								</div>
							</div>
						</div>
					</svelte:component>
				{/await}
			</section>
		</section>
	{/if}
	{#if data.orders?.length > 0 && data.featureConfig.references.hvac && PUBLIC_WOLTAIR_WEB_CODE !== 'WOLTAIR_PL'}
		<section class="page-wrapper mt-24-res">
			<Separator />
			<h2
				class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
			>
				{t('web.heat_pump.projects.heading')}
			</h2>

			<div
				class="center inset-x-0 mx-auto mt-16-res flex flex-col items-center gap-16-res-25 pb-5 sm:max-w-5xl sm:flex-row"
			>
				<div class="max-w-sm basis-4/12 sm:max-w-none">
					<img
						class="aspect-[3/2] h-auto w-full rounded-md object-cover"
						src="https://lh3.googleusercontent.com/Aj4h4zClfJWKS81sbqZqfZ5py1YJ8JjP3YYaz1ngnElB9VHA3G5ONDnjNN31LxqM2m1UbjE4O6Q-bb-xL7XgqMRT9sIRO9J-3GNOx0Fj1kTbpmOhkg"
						alt={t('web.heat_pump.projects.review.img.alt')}
					/>
					<p class="mt-4 text-sm-res">
						{t('web.heat_pump.projects.review.device', {
							deviceType: 'LG Therma V'
						})}
					</p>
				</div>

				<div class="max-w-sm basis-7/12 sm:max-w-none">
					<p class="mt-2 text-2xl-res font-light italic leading-snug">
						{t('web.heat_pump.projects.review.text')}
					</p>
					<div class="mt-8">
						<p class="text-1.5xl-res font-semibold">
							{t('web.heat_pump.projects.review.name')}
						</p>
						<p class="text-1.5xl-res">
							{t('web.heat_pump.projects.review.region')}
						</p>
					</div>
				</div>
			</div>

			<div class="inset-0 mx-auto mt-16 flex max-w-5xl flex-col items-center gap-8 md:flex-row">
				<div class="h-fit w-full max-w-lg basis-1/2">
					<p class="text-lg font-semibold">
						{t('web.heat_pump.projects.subheading')}
					</p>
					<div class="my-6 grid grid-cols-2">
						{#each data.orders as orderGroup}
							<a
								href="/{HEAT_PUMP}/{orderGroup.slug}"
								class="leading-0 col-span-1 h-fit text-sm text-primary-500 underline"
								>{`${orderGroup.region} (${orderGroup.value})`}</a
							>
						{/each}
					</div>
					<div class="col-span-2 pt-6">
						<span class="inline-block align-middle text-sm"
							>{t('web.heat_pump.projects.moreAbroad')}</span
						>
						<img src="/images/icons/flag/pl.svg" alt="" class="inline-block pl-2 align-middle" />
						<img src="/images/icons/flag/it.svg" alt="" class="inline-block pl-2 align-middle" />
						<img src="/images/icons/flag/de.svg" alt="" class="inline-block pl-2 align-middle" />
					</div>
				</div>

				<div class="max-w-md basis-1/2 md:max-w-none">
					<img src="/images/illustrations/map_cz.svg" alt="" />
				</div>
			</div>
		</section>
	{/if}

	{#if PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_DE' && data.largestCities}
		{@const formType = 'hvac'}
		<section class="page-wrapper my-16 flex items-center justify-center">
			<div
				class="flex max-w-5xl grid-cols-2 grid-rows-1 flex-col place-items-center gap-y-12 md:grid"
			>
				<div class="h-fit md:w-full md:py-12">
					<h3 class="!mt-0">{t('web.heat_pump.marketplace.cities')}</h3>
					<ul class="unstyled grid grid-cols-1 gap-1 3xs:grid-cols-2 md:mt-12">
						{#each data.largestCities as city}
							<li class="unstyled text-w-red-500 underline md:hover:font-bold">
								<a
									href="/{MARKETPLACE}/{URLPART_TYPE_LISTING[
										formType
									]}/{city.slug}?cityName={city.zip}&cityNameReal={city.name}&formType={formType}"
									>{city.name}</a
								>
							</li>
						{/each}
					</ul>
				</div>
				<div class="relative max-h-full w-full max-w-72 md:min-h-96 md:w-full md:max-w-none">
					<img
						src="/images/illustrations/map-de-bayern.webp"
						alt="DE map"
						loading="lazy"
						class="inset-x-0 mx-auto h-full object-contain md:absolute"
					/>
				</div>
			</div>
		</section>
	{/if}

	{#if data?.article && data.featureConfig.hvacPageArticle}
		<section class="page-wrapper">
			<ArticleV4 article={data?.article} referer={false} />
		</section>
	{/if}

	{#if data.faqs?.length}
		<Anchor id="faq" />
		<section class="page-wrapper mt-24-res">
			<Separator />
			<h2
				class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
			>
				{t('web.heat_pump.faq.heading')}
			</h2>

			<div class="mt-16-res flex flex-col flex-wrap gap-x-10 pb-16 lg:flex-row">
				{#each data.faqs as faq}
					<FAQ_wrap>
						<svelte:fragment slot="question">{faq.question}</svelte:fragment>
						<svelte:fragment slot="answer">{@html faq.answer}</svelte:fragment>
					</FAQ_wrap>
				{/each}
			</div>
		</section>
	{/if}

	{#if data.otherArticles?.length > 0}
		<section class="page-wrapper mt-16-res md:!max-w-[842px]">
			<Separator />
			<h2
				class="unstyled inset-x-0 mx-auto mt-6-res max-w-5xl text-center text-4.5xl-res font-extrabold tracking-normal"
			>
				{t('web.heat_pump.articles.heading')}
			</h2>

			<BlogBanner articles={data.otherArticles} hideTitle />
		</section>
	{/if}

	<section class="footer-people mt-28-res hidden h-[300px] md:block" />
{/if}

<style>
	.footer-people {
		background-image: url('/images/persons/woltair-people_2x_crop.webp');
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
	}
</style>
